import { render, staticRenderFns } from "./priceChange.vue?vue&type=template&id=1ee3fe0d"
import script from "./priceChange.vue?vue&type=script&lang=js"
export * from "./priceChange.vue?vue&type=script&lang=js"
import style0 from "./priceChange.vue?vue&type=style&index=0&id=1ee3fe0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports